export class SimpleHierachicalFilter {
  category: string;
  order: number;
  item: string[];

  constructor() {
    this.item = [];
  }
}
